import React, { useState, useCallback, useEffect } from 'react';
// import { Trans } from 'react-i18next';
function Footer() {
  
    return (
      <footer className="footer">
        <div className="container-fluid">
          <div className="d-sm-flex justify-content-center justify-content-sm-between py-2 w-100">
            <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2022</span>
            <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Dashboard  </span>
          </div>
        </div>
      </footer>
    );
}

export default Footer;